import { PunchupFormCombobox } from 'features/common/components/Punchup/primitives/forms/pickers/PunchupCombobox';
import moment from 'moment-timezone';
import { timezones } from './utils';
import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface PunchupTimezoneProps {
	/** @deprecated The form must be initialised with the timezone value in defaultValues.
	 *  This prop is no longer read — the select renders whichever value watch('timezone') returns. */
	eventTimezone?: string;
}

export const TimezoneSelect: FC<PunchupTimezoneProps> = ({ eventTimezone: _eventTimezone }) => {
	const { t } = useTranslation();
	/* Captured once — see CLAUDE.md "The clock in each label is read once, at mount". */
	const [now] = useState(() => moment());
	const options = useMemo(() => timezones(now, t), [now, t]);

	return (
		<PunchupFormCombobox
			id="timezone"
			name="timezone"
			label={t('createEvent-eventSummary-timezone')}
			options={options}
			placeholder={t('createEvent-eventSummary-timezone-placeholder', 'Select timezone...')}
			searchPlaceholder={t('createEvent-eventSummary-timezone-search', 'Search timezones...')}
		/>
	);
};
